if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector(".form");

        this.form.querySelector("[name=id]").disabled = false;
        this.smoothScrollToTop = document.querySelector(".variant-notice-msg");
        this.chillerOptionSelector = document.querySelectorAll(
          ".variantChiller__option"
        );
        this.chillerOptionSelector.forEach((chillerOptionElement) => {
          chillerOptionElement.addEventListener(
            "click",
            this.chillerOptionHandler.bind(this)
          );
        });

        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        const upsellATCBtn = document.querySelectorAll(".upsellATCCheckbox");
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.smoothScrollToTop.addEventListener("click", function () {
          console.log("Button clicked!");
          this.noticeWrapper = document.querySelector(
            ".variant-notice-wrapper"
          );
          if (this.noticeWrapper.classList.contains("notice-open")) {
            window.scrollTo({ top: 0, behavior: "smooth" });
          }
        });
        this.checkChillerVariantSelection();
      }
      smoothScrollToTop() {
        if (document.documentElement.scrollTop > 0) {
          // Scroll to the top using smooth behavior
          window.scrollBy(0, -40);
          requestAnimationFrame(scrollToTop);
        }
      }
      checkChillerVariantSelection() {
        // Assuming you have a container element with the class .variant-waterChiller
        const variantWaterChiller = document.querySelector(
          ".variant-waterChiller"
        );
        console.log("test");
        // Find all the input elements within the container
        const inputElements = variantWaterChiller.querySelectorAll("input");

        inputElements.forEach((input) => {
          if (input.checked) {
            const inputValue = input.value;
            if (inputValue.includes("Pro") || inputValue.includes("Standard")) {
              // Find the corresponding .water-chiller-accordion .Details
              const accordionDetails = document.querySelector(
                ".variantChiller-details"
              );

              // Add the 'open' attribute to the Details element
              accordionDetails.setAttribute("open", "true");
            }
          }
        });
      }
      chillerOptionHandler(evt) {
        console.log("chillerOptionHandler trigged");
        this.chillerOption = document.querySelectorAll(
          ".variantChiller__option"
        );
        this.optionSelected = evt.target;
        this.chillerOption.forEach((chillerOption) => {
          chillerOption.classList.remove("chiller__optionSelected");
        });
        evt.target.classList.add("chiller__optionSelected");
        console.log("evt.target element: " + evt.target);
        const wrapperElement = document.querySelector(
          ".variantChiller__optionsInput-wrapper"
        );
        const optionElements = document.querySelectorAll(
          ".variant__chiller-option"
        );

        if (this.optionSelected.getAttribute("data-option-value") === "Yes") {
          wrapperElement.style.transition = "height 0.2s ease";
          wrapperElement.style.height = "102px";

          optionElements.forEach((optionElement, index) => {
            optionElement.style.transition = "opacity 0.4s ease";
            optionElement.style.opacity = "1";
          });
        } else {
          const chillerOptionDeselectRadio = document.querySelector(
            ".variantChiller__optionsInput-wrapper input[value=No]"
          );
          chillerOptionDeselectRadio.checked = true;

          // Trigger the change event on the radio button to notify any listeners
          chillerOptionDeselectRadio.dispatchEvent(new Event("change"));
          optionElements.forEach((optionElement, index) => {
            optionElement.style.transition = "opacity 0.2s ease";
            optionElement.style.opacity = "0";
          });

          setTimeout(() => {
            wrapperElement.style.transition = "height 0.4s ease";
            wrapperElement.style.height = "0";
          }, (optionElements.length - 1) * 100);

          console.log("variant set to change");
        }

        /*
        if (this.optionSelected.getAttribute('data-option-value') === 'Yes') {
          
          this.optionSelected.closest(".variant__chiller-wrapper").classList.add("chiller__optionsOpen");
        } else {
          this.optionSelected.closest(".variant__chiller-wrapper").classList.remove("chiller__optionsOpen");
        }*/
      }
      /* =========================================================
                        Updated and modularized. 
                        7/10/2023 - Chud
      =========================================================
*/
      onSubmitHandler(evt) {
        evt.preventDefault();

        if (this.submitButton.getAttribute("aria-disabled") === "true") return;
        console.log("test");
        this.handleErrorMessage();
        this.toggleLoadingState(true);

        const formData = this.prepareFormData();
        const config = this.prepareFetchConfig(formData);

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => this.handleFetchResponse(response))
          .catch((error) => console.error(error))
          .finally(() => {
            this.handleUpsellAddition();
            this.toggleLoadingState(false);
          });
      }

      prepareFormData() {
        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        return formData;
      }

      prepareFetchConfig(formData) {
        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];
        config.body = formData;
        return config;
      }

      handleFetchResponse(response) {
        if (response.status) {
          this.handleErrorMessage(response.description);
          this.updateSoldOutState();
          this.error = true;
          return;
        }

        if (!this.cart) {
          window.location = window.routes.cart_url;
          return;
        }

        this.error = false;
        const quickAddModal = this.closest("quick-add-modal");
        if (quickAddModal) {
          document.body.addEventListener(
            "modalClosed",
            () => {
              setTimeout(() => {
                this.cart.renderContents(response);
              });
            },
            { once: true }
          );
          quickAddModal.hide(true);
        } else {
          this.cart.renderContents(response);
        }
      }

      updateSoldOutState() {
        const soldOutMessage =
          this.submitButton.querySelector(".sold-out-message");
        if (!soldOutMessage) return;
        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.querySelector("span").classList.add("hidden");
        soldOutMessage.classList.remove("hidden");
      }

      toggleLoadingState(isLoading) {
        if (isLoading) {
          this.submitButton.setAttribute("aria-disabled", true);
          this.submitButton.classList.add("loading");
          this.querySelector(".loading-overlay__spinner").classList.remove(
            "hidden"
          );
        } else {
          this.submitButton.classList.remove("loading");
          if (this.cart && this.cart.classList.contains("is-empty"))
            this.cart.classList.remove("is-empty");
          if (!this.error) this.submitButton.removeAttribute("aria-disabled");
          this.querySelector(".loading-overlay__spinner").classList.add(
            "hidden"
          );
        }
      }

      handleUpsellAddition() {
        // ... (Your upsell handling code here | copy paste one from product-form.js)
      }
      /* =========================================================
                       FIN 
      =========================================================
*/

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
      upsellAddToCartHandler(evt) {
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        if (this.cart) {
          this.cart.setActiveElement(document.activeElement);
        }
        const clickedElement = evt.target;
        const getProductId = (element) =>
          clickedElement
            .closest(".product-upsell-box")
            .getAttribute("data-product-id");
        const getSectionUrl = (element) =>
          clickedElement
            .closest(".product-upsell-box")
            .getAttribute("data-section-url");
        const getUpsellProductId = getProductId(clickedElement);
        const getUpsellSectionUrl = getSectionUrl(clickedElement);

        const sectionIdData = document
          .querySelector(".product")
          .getAttribute("data-section-id");
        const getUpsellQuantity = document.getElementById(
          "Quantity-" + sectionIdData
        ).value;
        if (event.target.checked) {
          console.log("Closest Product Id: " + getUpsellProductId);
          console.log("Closest Product Section Url: " + getUpsellSectionUrl);
          var data = {
            id: getUpsellProductId,
            quantity: 1,
            sections: ["cart-drawer", "cart-icon-bubble"],
            sections_url: getUpsellSectionUrl,
          };

          fetch("/cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
          })
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                this.handleErrorMessage(response.description);

                const soldOutMessage =
                  this.submitButton.querySelector(".sold-out-message");
                if (!soldOutMessage) return;
                this.submitButton.setAttribute("aria-disabled", true);
                this.submitButton.querySelector("span").classList.add("hidden");
                soldOutMessage.classList.remove("hidden");
                this.error = true;
                return;
              } else if (!this.cart) {
                //window.location = window.routes.cart_url;
                //return;
              }

              this.error = false;
              const quickAddModal = this.closest("quick-add-modal");
              if (quickAddModal) {
                document.body.addEventListener(
                  "modalClosed",
                  () => {
                    setTimeout(() => {
                      this.cart.renderContents(response);
                    });
                  },
                  { once: true }
                );
                quickAddModal.hide(true);
              } else {
                this.cart.renderContents(response);
              }
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              if (this.cart && this.cart.classList.contains("is-empty"))
                this.cart.classList.remove("is-empty");
            });
        } else {
          var data = {
            updates: {},
            sections: ["cart-drawer", "cart-icon-bubble"],
            section_url: getUpsellSectionUrl,
          };
          data.updates[getUpsellProductId] = 0;

          fetch("/cart/update.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
          })
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                this.handleErrorMessage(response.description);

                const soldOutMessage =
                  this.submitButton.querySelector(".sold-out-message");
                if (!soldOutMessage) return;
                this.submitButton.setAttribute("aria-disabled", true);
                this.submitButton.querySelector("span").classList.add("hidden");
                soldOutMessage.classList.remove("hidden");
                this.error = true;
                return;
              } else if (!this.cart) {
                //window.location = window.routes.cart_url;
                //return;
              }

              this.error = false;
              this.cart.renderContents(response);
            })
            .catch((error) => {
              // Handle errors that occur during the request
              console.error("Error removing product from cart:", error);
            });
        }
      }
      upsellAlternativeAddOnTest(
        getUpsellProductId,
        getUpsellQuantity,
        getUpsellSectionUrl
      ) {
        var data = {
          id: getUpsellProductId,
          quantity: getUpsellQuantity,
          sections: ["cart-drawer", "cart-icon-bubble"],
          sections_url: getUpsellSectionUrl,
        };

        fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        })
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              //window.location = window.routes.cart_url;
              //return;
            }

            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              console.log("Upsell Alternative Response: " + response);
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
          });
      }
    }
  );
}
